import * as c from '../constants';
import { onWaiting } from '../../Actions';

export function isLoading(isLoading) {
    return {
        type: c.PROFILE_LOADING,
        isLoading
    }
}

export const checkFirstTime = () => {
    return (dispatch, getState, { history, session }) => {
        const profile = session.getItem('profile');
        if(profile.firsttime === 1) {
            return history.push(`/profile/${profile.username}/edit`);
        }
    }
}

export const getProfile = () => {
    return (dispatch, getState, { session }) => {
        const profile = session.getItem('profile');
        const country = session.getItem('countries');
        const sports = session.getItem('sports');

        const countryData = country.filter(item => parseInt(item.id, 0) === parseInt(profile.country, 0));
        const sportData = sports.filter(item => parseInt(item.id, 0) === parseInt(profile.sport,0));

        let countryName = 0;
        let countryId = 0;

        if(countryData.length > 0)  {
            countryName = countryData[0].name;
            countryId = countryData[0].id;
        }

        const data = Object.assign({}, profile, {
            country: countryId,
            country_name: countryName,
            sport_name: sportData[0].name
        })

        dispatch({
            type: c.PROFILE_DETAILS,
            data
        })
    }
}

export const getCountries = () => {
    return (dispatch, getState, { session }) => {
        const data = session.getItem('countries');
        dispatch({
            type: c.COUNTRIES,
            data
        })
    }
}

export const getSports = () => {
    return (dispatch, getState, { session }) => {
        const data = session.getItem('sports');
        dispatch({
            type: c.SPORTS,
            data
        })
    }
}

export const updateProfile = (data,username) => {
    return (dispatch, getState, { session, api, alert, history }) => {
        const newData = Object.assign({}, data, {
            _method: 'PUT'
        })
        dispatch(onWaiting(true));
        api.post(`/me/${username}`, newData, dispatch)
            .then(response => {
                dispatch(onWaiting(false));
                if(!response) return;
                const { user } = response;
                session.setItem('profile',user);
                history.push('/profile');
                alert.success('Profile successfully updated!');
            })
    }
}


// WEBPACK FOOTER //
// ./src/profile/actions/index.js